import { MutationCache, QueryClient } from '@tanstack/svelte-query';
import { toast } from './toast.svelte';
import { getErrorMessage } from '$lib/api/client';

let client: QueryClient | undefined;

export function getQueryClient(): QueryClient {
  if (!client) {
    client = new QueryClient({
      mutationCache: new MutationCache({
        onError(error, _variables, _context, mutation) {
          // A locally handled failure can keep its inline field context. Every
          // other mutation still needs visible feedback (including drag/drop).
          if (!mutation.options.onError) toast.error(getErrorMessage(error));
        }
      }),
      defaultOptions: {
        queries: {
          staleTime: 0,
          retry: 1,
          refetchOnWindowFocus: false
        }
      }
    });
  }
  return client;
}
